export default __webpack_public_path__ + "b041c5623f0a9b9e9c931c7fc7470c59.jpg";